module.exports = __webpack_public_path__ + "img/03.0833d5fb.png";